import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import { ChangeEvent, useEffect, useState } from "react";
import { ReservationPassenger } from "../../../types/common.types";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import CountryInput from "../../common/CountryInput";
import GeneralInput from "../../common/GeneralInput";
import { add } from "date-fns";
import { useGlobal } from "../../../context/global";
import * as CommonTypes from '../../../types/common.types'
import InputDropdown from "../../common/InputDropdown";


export default function EditPassengerReservation() {
    const { setMessage, setIsLoading } = useGlobal()
    const {user, editPassengerReservationId, setEditPassengerReservationId, setCurrentDay} = useAdmin()
    const [data, setData] =  useState<ReservationPassenger>({} as ReservationPassenger)
    const [agencies, setAgencies] = useState<CommonTypes.Agency[]>([])
    const [agencyName, setAgencyName] = useState<string>('')

    useEffect(() => {
        async function getInfo() {
            setIsLoading(true)
            try {
                const response = (await AdminService.getReservation(editPassengerReservationId!)).data
                const newData = {
                    ...response.passenger,
                    traspass_price: response.traspass_price,
                    reservation_remark: response.remark
                }
                setData(newData)
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false)
            }
        }
        getInfo()
    }, [])

    useEffect(() => {
            async function getList() {
                try {
                    const response = (await AdminService.listAgencies()).data
                    setAgencies(response)
                } catch (error) {
                    console.log(error)
                }
            }
            getList()
    }, [])

    console.log(data)

    function onChange(e: ChangeEvent<HTMLInputElement>) {
            const name = e.target.name
            const value = e.target.value
            setData(prevData => ({...prevData, [name]: value}))
    }
    function onSelectCountry(e: ChangeEvent<HTMLSelectElement>) {
        const name = e.target.name
        const value = e.target.value
        setData(prevData => ({...prevData, [name]: value}))
    }

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            let newData: Partial<ReservationPassenger> = {}
            if (agencyName) {
                console.log(agencies)
                const agency = agencies.find(agency => agency.name === agencyName)
                if (agency) {
                    newData = {
                        name: data.name,
                        email: data.email,
                        phone: data.phone || '',
                        rut_passport: data.rut_passport || '',
                        hotel: data.hotel || '',
                        nationality: data.nationality,
                        traspass_price: data.traspass_price,
                        age: data.age,
                        remark: data.remark || '',
                        reservation_remark: data.reservation_remark || '',
                        agency_id: agency.id
                    }
                } else return
            } else {
                newData = {
                    name: data.name,
                    email: data.email,
                    phone: data.phone || '',
                    rut_passport: data.rut_passport || '',
                    hotel: data.hotel || '',
                    nationality: data.nationality,
                    traspass_price: data.traspass_price,
                    age: data.age,
                    remark: data.remark || '',
                    reservation_remark: data.reservation_remark || '',
                }
            }
            
            console.log(agencyName)
            
            console.log(newData)
            await AdminService.editPassengerReservation(editPassengerReservationId!, newData)
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: 1}))
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: -1}))
            setMessage({
                type: 'success',
                content: 'Passenger reservation successfully edited'
            })
            setTimeout(() => setMessage(undefined), 2500)
            setEditPassengerReservationId(undefined)
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Edit passenger reservation</h1>
            {
                user?.user.agency_id !== data.agency_id &&
                <InputDropdown
                options={agencies}
                selector="name"
                keys={['name']}
                label="Change Agency ID"
                optionDefaultHeight={35}
                value={agencyName}
                onChange={(newValue: string) => {
                    setAgencyName(newValue)
                }}
                />
            }
            <GeneralInput
            label="Name"
            value={data?.name || ''}
            onChange={onChange}
            placeholder="Carlos Perez"
            name="name"
            required
            style={{marginBottom: '20px'}}
            />
            <GeneralInput
            label="Email"
            value={data?.email || ''}
            onChange={onChange}
            placeholder="example@example.com"
            name="email"
            required
            style={{marginBottom: '20px'}}
            />
            <GeneralInput
            label="Phone"
            value={data?.phone || ''}
            onChange={onChange}
            placeholder="+58 412-0713771"
            name="phone"
            style={{marginBottom: '20px'}}
            />
            <GeneralInput
            label="Rut / Passport"
            value={data?.rut_passport || ''}
            onChange={onChange}
            placeholder="XXXXXXXX-Z"
            name="rut_passport"
            required
            style={{marginBottom: '20px'}}
            />
            <GeneralInput
            label="Hotel"
            value={data?.hotel || ''}
            onChange={onChange}
            placeholder="APANATOR"
            name="hotel"
            style={{marginBottom: '20px'}}
            />
            <GeneralInput
            label="Age"
            value={data?.age || ''}
            onChange={onChange}
            placeholder="18"
            name="age"
            type="number"
            required
            style={{marginBottom: '20px'}}
            />
            <GeneralInput
            label="Passenger Remark"
            value={data?.remark || ''}
            onChange={onChange}
            placeholder="Vegetarian"
            name="remark"
            style={{marginBottom: '20px'}}
            />
            <div className="locations">
                <CountryInput
                label="Nationality"
                name="nationality"
                value={data?.nationality}
                onChange={onSelectCountry}
                style={{marginBottom: '20px'}}
                />
            </div>
            <GeneralInput
            label="Reservation Remark"
            value={data?.reservation_remark || ''}
            onChange={onChange}
            placeholder="Only needs a window seat"
            name="reservation_remark"
            style={{marginBottom: '20px'}}
            />
            {
                user?.user.agency_id !== data.agency_id &&
                <GeneralInput
                label="Traspass price"
                value={data?.traspass_price || ''}
                onChange={onChange}
                placeholder="100"
                name="traspass_price"
                type="number"
                style={{marginBottom: '20px'}}
                />
            }
            {/* Form fields for editing the reservation would go here */}
            <div className="actions" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button style={{backgroundColor: 'blue', color: 'white', border: 'none'}}
                >Save</button>
                <button 
                onClick={() => setEditPassengerReservationId(undefined)}
                type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                >Cancel</button>
            </div>
            <div className="close"
            onClick={() => setEditPassengerReservationId(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}